import { render } from "./BibliothequePage.vue?vue&type=template&id=bbb18bdc"
import script from "./BibliothequePage.vue?vue&type=script&lang=js"
export * from "./BibliothequePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__